module.exports = __webpack_public_path__ + "static/media/icon-pelican-color.9af93a69.png";